import {Box, Typography} from '@mui/material';

import {orangeColors, neutral} from '../../../layouts/theme/designSystem';

type KpiCardProps = {
  value: string;
  title: string;
  description: string;
};

export const KpiCard = ({value, title, description}: KpiCardProps) => {
  return (
    <Box
      sx={{
        backgroundColor: '#fff5e8',
        borderRadius: '5px',
        boxShadow: '0px 3px 10px 0px rgba(0, 0, 0, 0.15)',
        px: 2.5,
        py: 3,
        minHeight: {xs: '172px', md: '188px'},
        textAlign: 'center',
      }}
    >
      <Typography
        sx={{
          color: orangeColors[900],
          fontWeight: 700,
          fontSize: '2.25rem',
          lineHeight: 1.5,
        }}
      >
        {value}
      </Typography>

      <Typography
        sx={{
          color: neutral['primary-black'],
          fontWeight: 700,
          fontSize: '1.25rem',
          lineHeight: 1.5,
        }}
      >
        {title}
      </Typography>

      <Typography
        sx={{
          mt: 0.5,
          color: neutral['primary-black'],
          fontSize: '1rem',
          lineHeight: 1.5,
        }}
      >
        {description}
      </Typography>
    </Box>
  );
};
